import React, { useEffect, useState } from "react";
import { getFinishedBookingsByUserId } from "../components/services/BookingService";
import { Booking } from "../components/models/booking";
import Cookies from 'js-cookie';
import BookingItemShortCompleted from "../components/booking/components/items/BookingItemShortCompleted"



const UserCompletedRidesPage: React.FC = () => {

  const [bookings, setBookings] = useState<Booking[]>([]);
  const userId = Cookies.get('loggedUserId');

  const getUserFinishedRide = async () => {
    let bookings;
    if (userId) {
      bookings = await getFinishedBookingsByUserId(userId);
      if (bookings)
        setBookings(bookings)

    }
  };

  useEffect(() => {
    getUserFinishedRide();
  }, []);

  return (
    <div className="mt-2" style={{ fontFamily: "'Segoe UI', 'Roboto', sans-serif" }}>
      <div className="container mt-4">
        <div
          className="d-flex align-items-center bg-white border-0 rounded-top user-select-none border-start border-4 border-success px-2 py-2"
          style={{ letterSpacing: '0.05em' }}
        >
          <h5 className="mb-0 fw-bold text-dark ps-2" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
            Your Past Bookings
    </h5>
        </div>
      </div>


      <hr className="my-0" />
      <div className="mt-3">
        <BookingItemShortCompleted bookings={bookings} />
      </div>
    </div>

  );
};

export default UserCompletedRidesPage;
